import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../ui/widget';
import { AlumniService } from './alumni.service';
import { AlumniTab1Part } from './tabs/tab-1/alumni-tab-1.part';
import { AlumniTab2Part } from './tabs/tab-2/alumni-tab-2.part';
import { AlumniViewsPart } from './views/alumni-views.part';

@Component({
	selector: 'alumni-page',
	standalone: true,
	imports: [
		AlumniViewsPart,
		AlumniTab1Part,
		AlumniTab2Part,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './alumni.page.html',
})
export class AlumniPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: AlumniService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}